import {Button} from 'antd'
import {useMapContext} from '@/components/MindMap'

const PropertiesPaneButtonDesign = (props) => {
    const map = useMapContext()
    const selectedNodes = map.useSelectedNodes()
    const {canDesignWf, designWf} = map.commands
    const nodes = canDesignWf(selectedNodes)

    if (0 === nodes.length) {
        return null
    }

    const handleClick = () => designWf(nodes)

    return (
        <Button
            onClick={handleClick}
            {...props}
        >
            编辑
        </Button>
    )
}

export default PropertiesPaneButtonDesign
